import { reactive, useContext } from "@nuxtjs/composition-api";
import axios from "axios";
const state = reactive({
  iconCache: /* @__PURE__ */ new Map()
});
function useIconCache() {
  const { $config } = useContext();
  async function loadIcon(name) {
    if (state.iconCache.has(name)) {
      return state.iconCache.get(name);
    }
    try {
      const baseUrl = process.server ? $config.ssrMiddlewareUrl.replace("api", "_icon") : $config.middlewareUrl.replace("api", "_icon");
      const result = await axios.get(baseUrl + name);
      state.iconCache.set(name, result.data);
      return result.data;
    } catch (err) {
      return null;
    }
  }
  return {
    loadIcon
  };
}
export {
  useIconCache
};
